import { testimonials } from "@/mocks/articles";

export default function TestimonialSection() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          {testimonials.map((item, idx) => (
            <div key={item.seq} className="flex-1 flex flex-col lg:flex-row gap-6 lg:gap-10">
              <div className="flex-1">
                <div className="flex items-center gap-2 mb-6">
                  <span className="w-2 h-2 rounded-full bg-foreground-900"></span>
                  <span className="text-xs font-medium text-foreground-500 uppercase tracking-wider">
                    Community Verified
                  </span>
                </div>
                <blockquote className="font-heading text-xl md:text-2xl lg:text-3xl text-foreground-950 leading-relaxed mb-6 italic">
                  &ldquo;{item.quote}&rdquo;
                </blockquote>
                <div className="flex items-center gap-3">
                  <div>
                    <p className="text-sm font-bold text-foreground-900">
                      {item.author}
                    </p>
                    <div className="flex items-center gap-2 mt-0.5">
                      <span className="text-xs text-foreground-500">{item.role}</span>
                      <span className="flex items-center gap-1 text-xs text-primary-600">
                        <i className="ri-verified-badge-fill text-sm"></i>
                        {item.platform}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="w-full lg:w-64 aspect-[3/4] rounded-2xl overflow-hidden bg-background-100 flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.author}
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}